<template>
  <v-row justify="center">
    <v-dialog v-model="open" width="650px">
      <v-card dense>
        <v-toolbar elevation="0">
          <v-toolbar-title class="text--subtitle" style="padding-left: 10px">
            Remover o grupo <b>{{ removingGroup.name }}</b>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              :disabled="isFetching"
              icon
              @click="handleCloseDrmRemoveModal()"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="px-7 py-0">
          <v-row no-gutters>
            <v-col cols="12">
              <span>
                Você realmente deseja remover o grupo
                <b>{{ removingGroup.name }}</b
                >? <br />
                Todos os vídeos relacionados a esse grupo de segurança perderão
                suas configurações de segurança.
              </span>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="px-7 pb-6">
          <v-spacer></v-spacer>
          <v-btn
            class="px-6"
            text
            @click="handleCloseDrmRemoveModal"
            :disabled="isFetching"
          >
            {{ $t('message.cancel') }}
          </v-btn>
          <v-btn
            color="primary"
            :disabled="isFetching"
            :loading="isFetching"
            @click="handleRemove"
          >
            <span class="px-5">{{ $t('message.confirm') }}</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import drmApi from '@/services/drmApi'

export default {
  name: 'DrmRemoveGroup',
  components: {},
  data: () => ({
    open: false,
    isFetching: false,
    removingGroup: {
      name: '',
      id: '',
    },
  }),
  mounted() {
    this.$root.$on('drmRemoveGroupModal', (group) => {
      console.log('group', group)
      this.removingGroup = group
      this.open = true
    })
  },
  beforeDestroy() {
    this.$root.$off('removeMultipleModal')
    this.$root.$off('drmRemoveGroupModal')
  },
  methods: {
    async handleRemove() {
      this.isFetching = true
      this.$root.$emit('closeDrmAdvancedModal')
      try {
        await drmApi.deleteDrmGroup(this.removingGroup.id)
      } catch (e) {
        console.log('e', e)
      }
      this.$root.$emit('removeDrmGroup', this.removingGroup)
      this.handleCloseDrmRemoveModal()
      this.isFetching = false
    },
    handleCloseDrmRemoveModal() {
      this.open = false
    },
  },
}
</script>

<style></style>
